/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_League_Link_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only league organizers can link tournaments to this league" |
*
* @param {Err_Tournament_League_Link_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_league_link_forbidden = /** @type {((inputs?: Err_Tournament_League_Link_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_League_Link_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs de la ligue peuvent lier des tournois à cette ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores de la liga pueden vincular torneos a esta liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente organizadores da liga podem vincular torneios a esta liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori del campionato possono collegare tornei a questo campionato")
	return /** @type {LocalizedString} */ ("Only league organizers can link tournaments to this league")
});